<script setup lang="ts">
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';

interface GlassButtonProps {
	shape?: 'square' | 'circle';
	class?: HTMLAttributes['class'];
}

const props = withDefaults(defineProps<GlassButtonProps>(), {
	shape: 'circle'
});
</script>

<template>
	<button
		type="button"
		:class="
			cn(
				'flex cursor-pointer items-center justify-center overflow-hidden border border-white/10 bg-[rgba(102,102,102,0.3)] backdrop-blur-[6px] transition-colors hover:border-white/25 hover:bg-[rgba(102,102,102,0.5)]',
				shape === 'circle' ? 'rounded-full' : 'rounded-[2px]',
				props.class
			)
		"
	>
		<slot />
	</button>
</template>
